import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const AnswerOption = ({
  letter,
  text,
  isSelected,
  onClick,
  hasOtherOption,
  isOtherOption,
  onOtherTextChange,
  onOtherErrorChange, // Prop mới để truyền trạng thái lỗi lên cha
  otherText,
  isCheckbox = false,
}) => {
  const { t } = useTranslation();
  const [localOtherText, setLocalOtherText] = useState(otherText || "");
  const [error, setError] = useState(""); // State để quản lý lỗi trong component con

  useEffect(() => {
    setLocalOtherText(otherText || "");
  }, [otherText]);

  useEffect(() => {
    // Kiểm tra lỗi khi option "other" được chọn
    if (isSelected && isOtherOption && hasOtherOption) {
      if (!localOtherText.trim()) {
        setError(t("base.pleaseSpecifyOther")); // Thông báo lỗi dịch được
        onOtherErrorChange?.(true); // Thông báo lỗi cho component cha
      } else {
        setError("");
        onOtherErrorChange?.(false); // Xóa lỗi khi có nội dung
      }
    } else {
      setError("");
      onOtherErrorChange?.(false); // Không có lỗi nếu không chọn option "other"
    }
  }, [
    isSelected,
    isOtherOption,
    hasOtherOption,
    localOtherText,
    onOtherErrorChange,
    t,
  ]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setLocalOtherText(value);
    onOtherTextChange?.(value);
  };

  const handleInputClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      className={`flex gap-4 mt-4 w-full items-center bg-white rounded-xl border border-solid ${
        isSelected
          ? "border-[#253FF6] border-2 bg-[#FCF8E6]"
          : "border-stone-200"
      } min-h-[60px] cursor-pointer transition-all duration-200 hover:border-[#253FF6]/70`}
      onClick={onClick}
    >
      <div className="flex items-center px-6 py-4 w-full">
        <div className="flex items-center gap-3 w-full">
          {isCheckbox ? (
            <div className="flex-shrink-0 flex items-center justify-center">
              <div
                className={`w-5 h-5 border rounded-sm flex items-center justify-center ${
                  isSelected
                    ? "bg-white border-[#253FF6] border-2"
                    : "border-gray-300 bg-white"
                }`}
              >
                {isSelected && (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4 text-[#253FF6]"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </div>
            </div>
          ) : null}

          <div
            className={`flex flex-col flex-grow ${isCheckbox ? "ml-1" : ""}`}
          >
            {isSelected && hasOtherOption && isOtherOption ? (
              <>
                <input
                  type="text"
                  value={localOtherText}
                  onChange={handleInputChange}
                  onClick={handleInputClick}
                  className={`text-[#253FF6] rounded-md w-full focus:outline-none focus:border-none focus:ring-0 focus:ring-[#253FF6]/30 text-xl font-medium `}
                  placeholder={t("base.othersPleaseSpecify")}
                />
                {error && (
                  <span className="text-[#EF4056] text-sm mt-1">{error}</span>
                )}
              </>
            ) : (
              <span
                className={`text-xl ${
                  isSelected
                    ? "text-[#253FF6] font-bold"
                    : "font-medium text-[#A0A0A0]"
                }`}
              >
                {text}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnswerOption;
